export default {"src":"/_next/static/media/Group-27888.8ec59ed7.svg","height":392,"width":583};